import React from 'react';

declare module 'react' {
  function createFactory<P>(
    type: React.ComponentType<P> | string,
  ): (props?: P, ...children: React.ReactNode[]) => React.ReactElement<P>;
}

if (!(React as any).createFactory) {
  (React as any).createFactory = (type: any) => {
    return React.createElement.bind(null, type);
  };
}

export {};
